import React, { useEffect, useMemo, useState } from 'react'

import classNames from 'classnames'
import { Outlet, useLocation } from 'react-router-dom'

import Filter from '@components/music/filter/Filter'
import PageLayout from '@layout/PageLayout'
import useMusicPageTitle from '@pages/music/hooks/useMusicPageTitle'
import { useAudioContext } from '@providers/AudioContextProvider'
import AudioPreviewProvider from '@providers/AudioPreviewProvider'
import { SearchCategory } from '@services/SearchService'
import { useSession } from '@stores/globalData/globalData.store'
import { removeTrailing } from '@utils/formatters/string.formatter'
import PageRoutes from '@utils/page-routes'

import type { SearchConfig } from '@services/SearchService'
import type { FC } from 'react'

const searchConfig: SearchConfig = Object.freeze({
  [SearchCategory.TITLE]: 16,
})
const MusicPage: FC = () => {
  const location = useLocation()
  const session = useSession()
  const [sideFilterVisible, setSideFilterVisibility] = useState<boolean>(false)
  const { setUpAudioContext } = useAudioContext()
  const title = useMusicPageTitle()

  useEffect(() => {
    setUpAudioContext()
  }, [setUpAudioContext])

  const hideFooter = useMemo(() => {
    return (
      removeTrailing('/', location.pathname) !== PageRoutes.musicPath() ||
      !session.isDefaultCommunity()
    )
  }, [location.pathname, session])

  return (
    <PageLayout title={title} hideFooter={hideFooter} searchConfig={searchConfig}>
      <div
        data-testid="music-page"
        className={classNames('flex flex-row', {
          'h-full': hideFooter,
        })}>
        <Filter
          visible={sideFilterVisible}
          setSideFilterVisibility={() => setSideFilterVisibility(!sideFilterVisible)}
        />
        <AudioPreviewProvider>
          <Outlet context={{ setSideFilterVisibility }} />
        </AudioPreviewProvider>
      </div>
    </PageLayout>
  )
}

export default MusicPage
